import addresses from "../config/address";

const chainId = process.env.GATSBY_APP_CHAIN_ID;

export const CONTRACT_ADDRESS_RABBIT_ZERO = addresses.rabbit_zero_contract[chainId];
export const CONTRACT_ADDRESS_RABBIT_ONE = addresses.rabbit_one_contract[chainId];
export const CONTRACT_ADDRESS_PFP = addresses.pfp_contract[chainId];
export const CONTRACT_ADDRESS_UKRAINE = addresses.ukraine_contract[chainId];
export const CONTRACT_ADDRESS_ACCESS = addresses.access_contract[chainId];
export const CONTRACT_ADDRESS_MIGRATE = addresses.migrate[chainId];
